import * as React from "react";

const CrossSvg = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7437 15.041C16.0966 15.409 16.0829 15.992 15.7134 16.3432C15.3438 16.6944 14.7581 16.6809 14.4053 16.3129L7.99986 9.63282L1.59444 16.3129C1.24158 16.6809 0.655929 16.6944 0.286359 16.3432C-0.0832103 15.992 -0.0968839 15.409 0.255977 15.041L6.72085 8.29898L0.255972 1.55693C-0.0968891 1.18894 -0.0832148 0.605949 0.286355 0.254776C0.655924 -0.0963967 1.24157 -0.0828931 1.59443 0.285096L7.99986 6.96514L14.4053 0.285096C14.7581 -0.0828931 15.3438 -0.0963967 15.7134 0.254776C16.0829 0.605949 16.0966 1.18894 15.7437 1.55693L9.27886 8.29898L15.7437 15.041Z"
      fill="#1D202B"
    />
  </svg>
);

export default CrossSvg;
